import { useTranslation } from 'react-i18next';

import classes from './StepThree.module.css';

const StepThree = () => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      <figure className={classes.stepNumber}>
        <img
          className={classes.numberImg}
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imageNumberActivity02.png"
          alt="number"
        />
      </figure>
      <p className={classes.titleActivity}>{t('send_info')}</p>
      <p className={classes.descriptionActivity}>
        {t('completed_information')}
      </p>
    </>
  );
};

export default StepThree;
